import { configureStore } from "@reduxjs/toolkit";
import attestReducer from "./attestSlice";
import transferReducer from "./transferSlice";
import tokenReducer from "./tokenSlice";
import { updateVersion } from '../state/global/actions'
import application from '../state/application/reducer'
import multicall from '../state/multicall'

export const store = configureStore({
  reducer: {
    attest: attestReducer,
    transfer: transferReducer,
    tokens: tokenReducer,
    application,
    multicall: multicall.reducer,
  },
});
store.dispatch(updateVersion())

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
